import React, { Component } from 'react';
// import { Provider } from 'react-redux';
import { ApolloProvider } from '@apollo/react-hooks';
import ApolloClient, { InMemoryCache } from 'apollo-boost';
import { BrowserRouter as Router } from 'react-router-dom';


import { getToken } from './utils/utils';
import Routes from './Routes';
// import store from './store';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';

toast.configure();

const client = new ApolloClient({
  uri: 'https://shielded-garden-35276.herokuapp.com/graphql',
  // cache: new InMemoryCache(),
  request: operation => {
    const { token } = getToken('zenon_token') || '';
    operation.setContext({
      headers: {
        authorization: token ? `Bearer ${token}` : ''
      }
    })
  }
});
class App extends Component {

  render() {
    return (
      <ApolloProvider client={client}>
        <Router>
          <Routes/>
        </Router>
      </ApolloProvider>
     );
  }
}

export default App;
